import { archiveGenres } from '@/mocks/gossipContent';
import Reveal from '@/components/base/Reveal';

const ICON_TINT = [
  'text-primary-600 bg-primary-100',
  'text-accent-700 bg-accent-100',
  'text-secondary-800 bg-secondary-200',
  'text-primary-700 bg-primary-100',
  'text-accent-700 bg-accent-100',
  'text-foreground-700 bg-foreground-100',
];

export default function ArchiveSection() {
  return (
    <section id="archive" className="bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <div>
              <div className="flex items-center gap-2 text-xs">
                <span className="font-heading text-primary-600 tracking-widest">CH.04</span>
                <span className="h-px w-8 bg-background-300" />
                <span className="text-foreground-500">塌房合集 · 分类档案柜</span>
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-bold mt-3 tracking-tight">
                塌房合集<span className="text-primary-600">按类归档</span>
              </h2>
            </div>
            <p className="max-w-md text-sm text-foreground-600 leading-relaxed">
              从言语到商务、从私德到数据，红黑历史按翻车类型分柜收纳。每一个合集都带持续更新的检索与归档编号。
            </p>
          </div>
        </Reveal>

        <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {archiveGenres.map((g, idx) => (
            <Reveal key={g.id} delay={(idx % 3) * 60}>
              <a
                href="#archive"
                className="group flex h-full flex-col rounded-lg bg-background-100 border border-background-200/70 p-5 hover:border-primary-300 hover:bg-background-100/70 transition-colors"
              >
                <div className="flex items-start justify-between">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-md ${ICON_TINT[idx % ICON_TINT.length]}`}>
                    <i className={`${g.icon} text-2xl w-6 h-6 flex items-center justify-center`} />
                  </span>
                  <span className="font-heading text-3xl font-bold text-background-200 group-hover:text-primary-200 transition-colors">
                    {String(g.id).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="font-heading text-lg font-bold mt-4 group-hover:text-primary-700 transition-colors">{g.name}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{g.desc}</p>
                <div className="mt-auto flex items-center justify-between pt-5">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50 px-2.5 py-1 text-xs text-foreground-500">
                    <i className="ri-file-list-line w-4 h-4 flex items-center justify-center" />
                    {g.tag}
                  </span>
                  <span className="font-heading text-sm font-semibold text-primary-600">
                    {g.count} 篇合集
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}